import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../screens/Home";
import PrivateRoute from "../screens/PrivateRoutes";
import BlockRegisterRoutes from "./BlockRegisterRoutes";
import ConsumptionRegisterRoutes from "./ConsumptionRegisterRoutes";
import MedicineList from "../screens/MedicineList";
import SeasonsRoutes from "./SeasonsRoutes";
import Panel from "../screens/Panel/Index";
import LabRegisterRoutes from "./LabRegisterRoutes";
import Tutorials from "../screens/Tutorials/Tutorials";
import Inventory from "../screens/Inventory/Inventory";
import NotFound from "../screens/NotFound";
import ProductClasses from "../screens/ProductClasses/ProductClasses";
import ProductSubClasses from "../screens/ProductClasses/ProductSubClasses/ProductSubClasses";
import Blogs from "../screens/Blogs/Blogs";
import Users from "../screens/Users/Users";
import ClientPurchases from "../screens/ClientPurchases/ClientPurchases";
import BannersAndPostsRoutes from "./BannersAndPostsRoutes";

const HomeRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route
        path="/registroLaboratorio/*"
        element={
          <PrivateRoute allowedRoles={["SuperAdmin", "EcosystemEditor"]}>
            <LabRegisterRoutes />
          </PrivateRoute>
        }
      />
      <Route
        path="/registroBloques/*"
        element={
          <PrivateRoute allowedRoles={["SuperAdmin", "EcosystemEditor"]}>
            <BlockRegisterRoutes />
          </PrivateRoute>
        }
      />
      <Route
        path="/registroConsumo/*"
        element={
          <PrivateRoute allowedRoles={["SuperAdmin", "EcosystemEditor"]}>
            <ConsumptionRegisterRoutes />
          </PrivateRoute>
        }
      />

      <Route
        path="/listaMedicina"
        element={
          <PrivateRoute allowedRoles={["EcosystemEditor", "SuperAdmin"]}>
            <MedicineList />
          </PrivateRoute>
        }
      />

      <Route
        path="/temporadas/*"
        element={
          <PrivateRoute allowedRoles={["EcosystemEditor", "SuperAdmin"]}>
            <SeasonsRoutes />
          </PrivateRoute>
        }
      />

      <Route
        path="/panel/*"
        element={
          <PrivateRoute allowedRoles={["SuperAdmin"]}>
            <Routes>
              <Route path="/" element={<Panel />} />
              <Route path="/*" element={<NotFound />} />
            </Routes>
          </PrivateRoute>
        }
      />

      <Route
        path="/productos/*"
        element={
          <PrivateRoute allowedRoles={["SuperAdmin", "StoreEditor"]}>
            <Routes>
              <Route path="/" element={<ProductClasses />} />
              <Route path="/:productClassId" element={<ProductSubClasses />} />
            </Routes>
          </PrivateRoute>
        }
      />
      <Route
        path="/blogs"
        element={
          <PrivateRoute allowedRoles={["SuperAdmin", "StoreEditor"]}>
            <Blogs />
          </PrivateRoute>
        }
      />
      <Route
        path="/tutoriales"
        element={
          <PrivateRoute allowedRoles={["SuperAdmin", "StoreEditor"]}>
            <Tutorials />
          </PrivateRoute>
        }
      />

      <Route
        path="/inventario"
        element={
          <PrivateRoute allowedRoles={["SuperAdmin", "StoreEditor"]}>
            <Inventory />
          </PrivateRoute>
        }
      />
      <Route
        path="/purchases"
        element={
          <PrivateRoute allowedRoles={["SuperAdmin", "StoreEditor"]}>
            <ClientPurchases />
          </PrivateRoute>
        }
      />

      <Route
        path="/users"
        element={
          <PrivateRoute allowedRoles={["SuperAdmin"]}>
            <Users />
          </PrivateRoute>
        }
      />

      <Route path="/*" element={<NotFound />} />

      <Route
        path="/bannersAndPosts/*"
        element={
          <PrivateRoute allowedRoles={["StoreEditor", "SuperAdmin"]}>
            <BannersAndPostsRoutes />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default HomeRoutes;
